<div *ngIf="surveyCompleted">
    <h3
        class="text-center mt-3"
        i18n="@@SurveyCompleteClickToNavToProfile"
        t="SurveyCompleteClickToNavToProfile"
        >Thank you for completing the survey, click here to navigate to profile.</h3
    >
</div>
<div *ngIf="!surveyCompleted">
    <h3 class="text-center mt-3 mb-4" i18n="@@3125261189712736576" t="3125261189712736576"
        >How you rate your Onboarding Process Experience</h3
    >
    <form [formGroup]="surveyForm">
        <div class="container">
            <div class="d-flex justify-content-center">
                <div class="col-6 mb-3" style="margin-left: 280px;">
                    <ngx-input-star-rating formControlName="Rating"></ngx-input-star-rating>
                    <tsl-error
                        *ngIf="
                            SurveyControls.Rating.errors &&
                            (SurveyControls.Rating.dirty || SurveyControls.Rating.touched)
                        "
                    >
                        <span i18n="@@Required" t="Required">Required</span>
                    </tsl-error>
                </div>
                <div class="col-6 mb-3" style="margin-left: 280px;">
                    <tsl-form-field class="w-100">
                        <tsl-label i18n="@@COMMENTS" t="COMMENTS">COMMENTS</tsl-label>
                        <!-- todo ttp -->
                        <textarea
                            tslInput
                            fullWidth
                            maxlength="2000"
                            shape="round"
                            name="Comments"
                            formControlName="Comments"
                            tPlaceholder="1518361652268997674" i18n-placeholder="@@1518361652268997674"
                            placeholder="Comments (Optional)"
                        >
                        </textarea>
                        <tsl-hint align="below" class="max-length-hint"
                            >{{ Comments?.value?.length || 0 }} / 2000
                        </tsl-hint>
                    </tsl-form-field>
                </div>
                <div class="grid" style="margin-left: 580px;">
                    <div class="row">
                        <div fxFlex="50" class="right">
                            <button
                                tsl-button
                                color="blue"
                                filled
                                (click)="saveSurvey()"
                                i18n="@@Submit"
                                t="Submit"
                                >Submit</button
                            >
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </form>
</div>
